import Vue from 'vue'
import Vant from 'vant'
import App from './App'
import router from './router'
import store from './store'
import VueLocalStorage from 'vue-localstorage'
import _ from 'lodash'
import lrz from 'lrz'
import CONST from '@/utils/const'
import * as Filters from './filters'
import * as Utils from '@/utils/index'
import './router-permission' // router permission control
import 'vant/lib/index.css'
import '@/styles/index.css' // global css
import axios from 'axios'
import $ from 'jquery'
import VueAxios from 'vue-axios'
import moment from 'moment/moment'

// import Vconsole from 'vconsole'
// const vConsole = new Vconsole()
Vue.prototype.$jquery = $
Vue.use(Vant)
Vue.use(VueLocalStorage)
Vue.use(VueAxios, axios)
Vue.config.productionTip = false
axios.defaults.baseURL = 'https://cx2018.chunxue.cn/api'
axios.defaults.headers.post["Content-type"] = "application/x-www-form-urlencoded"
Vue.prototype['BACKEND_API'] = process.env.BACKEND_API
Vue.prototype['CONST'] = CONST
Vue.prototype['Filters'] = Filters
Vue.prototype['Utils'] = Utils
Vue.prototype._ = _
Vue.prototype['lrz'] = lrz
Vue.filter('moment', function (value, formatString) {
    formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
    // return moment(value).format(formatString); // value可以是普通日期 20170723
    return moment.unix(value).format(formatString); // 这是时间戳转时间
});
const msg = (type, info) => {
  Vue.prototype.$notify({ type: type, message: info })
}
Vue.prototype['success'] = (info) => {
  msg('success', info)
}
Vue.prototype['warning'] = (info) => {
  msg('warning', info)
}
Vue.prototype['info'] = (info) => {
  msg('primary', info)
}
Vue.prototype['error'] = (info) => {
  msg('danger', info)
}

Vue.prototype['toast'] = (info) => {
  Vue.prototype.$toast(info)
}

Vue.prototype['alert'] = (info) => {
  return new Promise((resolve) => {
    if (Vue.prototype.$dialog) {
      Vue.prototype.$dialog.alert({
        title: CONST.TIP.TITLE,
        message: info
      }).then(() => {
        resolve()
      })
    }

  })
}

Vue.prototype['confirm'] = (info) => {
  return new Promise((resolve, reject) => {
    Vue.prototype.$dialog.confirm({
      title: CONST.TIP.TITLE,
      message: info
    }).then(() => {
      resolve()
    }).catch(() => {
      reject()
    })
  })
}

// 注册系统基础组件
const baseComponents = require.context(
  '@/components/base',
  false,
  /Base[\w-]+\.vue$/
)
baseComponents.keys().forEach((fileName) => {
  const config = baseComponents(fileName)
  const name = Vue.prototype._.camelCase(
    fileName.replace(/^\.\/_/, '').replace(/\.\w+$/, '')
  )
  Vue.component(name, config.default || config)
})

// 注册系统基础过滤器
Object.keys(Filters).forEach(key => {
  Vue.filter(key, Filters[key])
})

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js